import Stack from '@mui/material/Stack';
import type { SignatureSelectOption } from 'components/editor/signatures/signature-select';
import { SignatureSelect } from 'components/editor/signatures/signature-select';
import { useCurrentUser } from 'providers/UserProvider';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DraggableSignatureButton } from './DraggableSignatureButton';

export default function Signatures() {
  const { t } = useTranslation();
  const {
    data: { accountId },
  } = useCurrentUser();
  const [selectedSignee, setSelectedSignee] = useState<SignatureSelectOption | null | undefined>(null);

  return (
    <Stack direction="column" pb={6}>
      <Stack direction="column" gap={1.5}>
        <SignatureSelect
          value={selectedSignee}
          onChange={(newValue) => setSelectedSignee(newValue)}
          accountId={accountId}
          placeholder={t('editor.signature.search_placeholder')}
          label={t('editor.signature.for')}
        />
        <DraggableSignatureButton signee={selectedSignee} />
      </Stack>
    </Stack>
  );
}
